module.exports = __webpack_public_path__ + "img/uponor.13d0fb28.jpg";